/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (cass, scope)
  {
    this.cass = cass;
    this.scope = scope;
  }


  getID ()
  {
    return this.cass.id;
  }


  getUser ()
  {
    return this.cass.user;
  }


  getSector ()
  {
    return this.cass.sector;
  }


  getPlanet ()
  {
    return this.cass.planet;
  }


  getCoords ()
  {
    return this.cass.coords;
  }


  getLocation ()
  {
    return this.cass.location;
  }


  getResource ()
  {
    const { args } = this.cass;

    return args ? args.resource : null;
  }


  isCenter ()
  {
    return this.getCoords().equals(this.scope.getSector().getCass().getCenter());
  }


}
